'use client';
import axios from 'axios';
import { useEffect, useState } from 'react';
import Link from 'next/link';
import classes from './UpNext.module.css';

const UpNext = (props) => {
	const { collection } = props;
	const [articleArr, setArticleArr] = useState([]);

	const fetchCollectionArticles = async (collections) => {
		await axios
			.get(`${process.env.NEXT_PUBLIC_SERVER_API}/api/blogs`, {
				params: {
					tag: collections.tags.join(',').replace(/ /g, ''),
					limit: 3,
				},
			})
			.then((res) => {
				setArticleArr(res.data);
			})
			.catch((err) => {
				console.log(err);
			});
	};

	useEffect(() => {
		if (collection) {
			fetchCollectionArticles(collection);
		}
	}, [collection]);

	return (
		<>
			{articleArr.length > 0 && (
				<div className={classes.main}>
					<h3 className={classes.sectionText}>Up Next</h3>
					<div className={classes.articleGrid}>
						{articleArr.map((article, idx) => (
							<Link
								key={idx}
								className={classes.link}
								href={`/blog/${article._id}`}
							>
								<img
									src={`${article.picture}?tr=w-500`}
									referrerPolicy="no-referrer"
									alt={article.title}
									className={classes.picture}
								/>

								<div className={classes.description}>
									<h2 className={classes.title}>{article.title}</h2>

									<div className={classes.infoSection}>
										<div className={classes.tags}>
											{article.tags?.length > 0 &&
												article.tags.map((i, idx) => (
													<h3 key={idx} className={classes.tag}>
														#{i}
													</h3>
												))}
										</div>

										<h3 className={classes.authorName}>
											Written by {article.author.firstName}{' '}
											{article.author.lastName !== 'undefined'
												? article.author.lastName
												: ''}
										</h3>
									</div>
								</div>
							</Link>
						))}
					</div>
				</div>
			)}
		</>
	);
};

export default UpNext;
